import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { SummaryContractInfo } from '@mwe/models';
import { InfoTextIconComponent } from '../../info-text/info-text-icon.component';

@Component({
  selector: 'mwe-product-summary-contract-info',
  imports: [CommonModule, TranslatePipe, InfoTextIconComponent],
  templateUrl: './product-summary-contract-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductSummaryContractInfoComponent {
  contractInfos = input.required<SummaryContractInfo>();
  showDeliveryInfos = input<boolean>(false);

  isDeliveryDate = computed<boolean>(() => {
    const { startDelivery } = this.contractInfos();
    // Check whether we have a translation path concat with '.'
    return !!startDelivery && !startDelivery.includes('.');
  });
}
